module.exports = __webpack_public_path__ + "static/media/CNSA-MAIA-Case-Manager-Training-mini.e401fde1.jpg";